let transform = (entities, entity, ctx) => {
    ctx.globalCompositeOperation = 'source-atop';
};

export default Object.freeze({
    transform
});
